
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("ihPnL", function(module, exports) {
$parcel$export(module.exports, "CommentEditorWithAI", () => $1a816a3f0ae6599c$export$d510fc3619128deb);
$parcel$export(module.exports, "CommentEditorWithAIContext", () => $1a816a3f0ae6599c$export$732e8ee983981ce0);
$parcel$export(module.exports, "default", () => $1a816a3f0ae6599c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $aOAkU = parcelRequire("aOAkU");
var $b1fSH = parcelRequire("b1fSH");

var $9skjA = parcelRequire("9skjA");

var $bmoS1 = parcelRequire("bmoS1");

var $8oOr4 = parcelRequire("8oOr4");

var $284TU = parcelRequire("284TU");

var $6t0ps = parcelRequire("6t0ps");

var $4DuXn = parcelRequire("4DuXn");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");

var $coXKe = parcelRequire("coXKe");

var $hYQLQ = parcelRequire("hYQLQ");

var $b2X8J = parcelRequire("b2X8J");

var $bYv34 = parcelRequire("bYv34");

var $fIu6L = parcelRequire("fIu6L");

var $kZiT0 = parcelRequire("kZiT0");

var $hOfDU = parcelRequire("hOfDU");
const $1a816a3f0ae6599c$export$d510fc3619128deb = ({ onChange: onChange, onExpanded: onExpanded, placeholder: placeholder })=>{
    const [{ currentCommentType: currentCommentType, showGeneratedComment: showGeneratedComment, isLoading: isLoading }, { acceptSuggestedComment: acceptSuggestedComment, setShowGeneratedComment: setShowGeneratedComment, setCurrentCommentType: setCurrentCommentType }] = (0, $fIu6L.useAICommentsStates)();
    const { userPreferredLayout: userPreferredLayout } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const { trackAIResultAction: trackAIResultAction, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $b1fSH.useAIEventsInstrumentation)();
    const { handleCommentButtonClick: handleCommentButtonClick } = (0, $kZiT0.useAICommentsInteraction)();
    const onDismiss = (0, $eJOHy.useCallback)((isDiscard)=>{
        trackAIInteractionDismiss({
            attributes: {
                aiExperienceName: currentCommentType ?? undefined,
                dismissedAction: isDiscard ? 'discardButtonClicked' : 'cancelButtonClicked'
            }
        });
        setShowGeneratedComment(false);
        setCurrentCommentType(null);
        onExpanded?.();
    }, [
        trackAIInteractionDismiss,
        currentCommentType,
        setShowGeneratedComment,
        setCurrentCommentType,
        onExpanded
    ]);
    const onInsertComment = (0, $eJOHy.useCallback)((comment)=>{
        trackAIResultAction('insert', {
            attributes: {
                aiExperienceName: currentCommentType ?? undefined
            }
        });
        setShowGeneratedComment(false);
        currentCommentType && acceptSuggestedComment(currentCommentType);
        onExpanded?.();
        onChange?.(comment, 'ai-smart-reply');
    }, [
        trackAIResultAction,
        currentCommentType,
        setShowGeneratedComment,
        acceptSuggestedComment,
        onExpanded,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9skjA.default), {
        shouldFitContainer: true,
        spacing: "none",
        testId: "canned-comments.ui.ai-comments.ai-container",
        isLoading: isLoading && showGeneratedComment,
        hasNewBorderExperience: true,
        // The breadcrumbs have a z-index of 99; the AI container needs a lower z-index to prevent overlap.
        zIndex: userPreferredLayout === 'WIDE' ? 98 : undefined
    }, showGeneratedComment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hOfDU.default), {
        isLoading: isLoading,
        onDismiss: onDismiss,
        onInsertComment: onInsertComment
    }), !showGeneratedComment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2X8J.CannedCommentsPlaceholder), {
        onClick: onExpanded,
        onFocus: onExpanded,
        placeholder: placeholder,
        hiddenBorder: true,
        renderCannedCommentOptions: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYv34.CommentButtonGroup), {
                onButtonClick: handleCommentButtonClick
            }),
        isAIRepliesEnabled: true
    }));
};
const $1a816a3f0ae6599c$export$732e8ee983981ce0 = ({ children: children })=>{
    const singleInstrumentationId = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    const attributes = {
        aiFeatureName: (0, $hYQLQ.AI_COMMENTS_FEATURE)
    };
    const issueKey = (0, $bmoS1.useIssueKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1a816a3f0ae6599c$var$ReduxConnectedJiraIssueAICommentsContainer, {
        scope: issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aOAkU.AIEventsInstrumentationProvider), {
        config: {
            ...attributes,
            product: 'jira',
            subproduct: 'jira',
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            isAIFeature: 1,
            singleInstrumentationID: singleInstrumentationId.current,
            customAnalyticsFire: (payload, event)=>(0, $gCeeo.fireTrackAnalytics)(event, payload)
        }
    }, children)));
};
const $1a816a3f0ae6599c$var$ReduxConnectedJiraIssueAICommentsContainer = (0, $284TU.connect)((state)=>({
        totalOfComments: (0, $4DuXn.totalCommentsSelector)(state),
        hasMissingAssignee: (0, $6t0ps.fieldSelector)((0, $8oOr4.ASSIGNEE))(state)?.value === null,
        hasMissingDescription: (0, $6t0ps.fieldSelector)((0, $8oOr4.DESCRIPTION))(state)?.adfValue?.content.length === 0
    }), {})((0, $fIu6L.JiraIssueAICommentsContainer));
const $1a816a3f0ae6599c$var$CommentEditorWithAIExports = {
    CommentEditorWithAI: $1a816a3f0ae6599c$export$d510fc3619128deb,
    CommentEditorWithAIContext: $1a816a3f0ae6599c$export$732e8ee983981ce0
};
var $1a816a3f0ae6599c$export$2e2bcd8739ae039 = $1a816a3f0ae6599c$var$CommentEditorWithAIExports;

});
parcelRegister("b1fSH", function(module, exports) {
$parcel$export(module.exports, "useAIEventsInstrumentation", () => $48c758f1d390e21e$export$ddf49ad062368ad2);

var $eJOHy = parcelRequire("eJOHy");

var $fCkfV = parcelRequire("fCkfV");

var $3VCQy = parcelRequire("3VCQy");

var $ftN6c = parcelRequire("ftN6c");

var $9Sbhc = parcelRequire("9Sbhc");

var $4ydDU = parcelRequire("4ydDU");

var $gSINT = parcelRequire("gSINT");

var $jh4uf = parcelRequire("jh4uf");

var $lmKRx = parcelRequire("lmKRx");
const $48c758f1d390e21e$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $eJOHy.useContext)((0, $9Sbhc.AIEventsInstrumentationContext));
    if (customConfig) context = {
        config: {
            ...(0, $4ydDU.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $lmKRx.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $eJOHy.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $fCkfV.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $jh4uf.AISessionState).unset,
            nextState: (0, $fCkfV.P).union((0, $jh4uf.AISessionState).viewed, (0, $jh4uf.AISessionState).error, (0, $jh4uf.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $jh4uf.AISessionState).initiated,
            nextState: (0, $fCkfV.P).union((0, $jh4uf.AISessionState).submitted, (0, $jh4uf.AISessionState).actioned, (0, $jh4uf.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $eJOHy.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $3VCQy.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $eJOHy.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes
            }
        };
        return (0, $fCkfV.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $gSINT.getTagsWithPlatfromTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $fCkfV.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $fCkfV.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        aiExperienceName,
        aiFeatureName,
        product,
        proactiveGeneratedAI,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        userGeneratedAI,
        isAIFeature,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents
    ]);
    const trackAIInteractionInit = (0, $eJOHy.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $jh4uf.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $eJOHy.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $jh4uf.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $eJOHy.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $jh4uf.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $eJOHy.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $jh4uf.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $eJOHy.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $jh4uf.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $eJOHy.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $jh4uf.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $eJOHy.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $jh4uf.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    return {
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
};

});
parcelRegister("gSINT", function(module, exports) {
$parcel$export(module.exports, "getTagsWithPlatfromTag", () => $a55f5445ec41ef46$export$8dd34cb3211cf994);
const $a55f5445ec41ef46$export$8dd34cb3211cf994 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};

});


parcelRegister("bYv34", function(module, exports) {
$parcel$export(module.exports, "CommentButtonGroup", () => $048e22c50dce3177$export$852ffb6112f1aae3);

var $eJOHy = parcelRequire("eJOHy");

var $48q59 = parcelRequire("48q59");

var $5CSKW = parcelRequire("5CSKW");

var $lRq8t = parcelRequire("lRq8t");

var $fIu6L = parcelRequire("fIu6L");
const $048e22c50dce3177$export$852ffb6112f1aae3 = ({ onButtonClick: onButtonClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ availableCommentTypeOptions: availableCommentTypeOptions }] = (0, $fIu6L.useAICommentsStates)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), {
        label: ""
    }, availableCommentTypeOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
            spacing: "compact",
            onClick: ()=>onButtonClick(option.value),
            key: option.value,
            "aria-label": formatMessage(option.message)
        }, formatMessage(option.message))));
};

});
parcelRegister("fIu6L", function(module, exports) {
$parcel$export(module.exports, "JiraIssueAICommentsContainer", () => $2d19e9c880cf2878$export$c65ed21eaf08fc53);
$parcel$export(module.exports, "useAICommentsStates", () => $2d19e9c880cf2878$export$a504bc7744cc367c);
$parcel$export(module.exports, "useCurrentComment", () => $2d19e9c880cf2878$export$32679da3f57e8e7a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $gxWPa = parcelRequire("gxWPa");
const $2d19e9c880cf2878$export$d4c72bab9d6cc13a = {
    availableCommentTypeOptions: [],
    availableCommentTypes: [],
    suggestedComments: null,
    acceptedCommentTypes: [],
    currentCommentType: null,
    isLoading: false,
    showGeneratedComment: false
};
const $2d19e9c880cf2878$export$b7e5745f481149f9 = (suggestedComments)=>({ setState: setState })=>{
        setState({
            suggestedComments: suggestedComments
        });
    };
const $2d19e9c880cf2878$export$e8cd75c4cacbbbeb = (currentCommentType)=>({ setState: setState })=>{
        setState({
            currentCommentType: currentCommentType
        });
    };
const $2d19e9c880cf2878$export$9eaa806651dd33f0 = (isLoading)=>({ setState: setState })=>{
        setState({
            isLoading: isLoading
        });
    };
const $2d19e9c880cf2878$export$771df637abf3ab45 = (showGeneratedComment)=>({ setState: setState })=>{
        setState({
            showGeneratedComment: showGeneratedComment
        });
    };
const $2d19e9c880cf2878$export$c822f70817f59389 = (commentType)=>({ setState: setState, getState: getState }, props)=>{
        const acceptedCommentTypes = getState().acceptedCommentTypes.concat(commentType);
        const { commentTypes: commentTypes, commentTypeOptions: commentTypeOptions } = (0, $gxWPa.getAvailableCommentTypeOptions)({
            ...props,
            acceptedCommentTypes: acceptedCommentTypes
        });
        setState({
            availableCommentTypes: commentTypes,
            availableCommentTypeOptions: commentTypeOptions,
            currentCommentType: null,
            suggestedComments: null,
            acceptedCommentTypes: acceptedCommentTypes
        });
    };
const $2d19e9c880cf2878$export$e324594224ef24da = {
    setSuggestedComments: $2d19e9c880cf2878$export$b7e5745f481149f9,
    setCurrentCommentType: $2d19e9c880cf2878$export$e8cd75c4cacbbbeb,
    acceptSuggestedComment: $2d19e9c880cf2878$export$c822f70817f59389,
    setShowGeneratedComment: $2d19e9c880cf2878$export$771df637abf3ab45,
    setIsLoading: $2d19e9c880cf2878$export$9eaa806651dd33f0
};
const $2d19e9c880cf2878$export$c65ed21eaf08fc53 = (0, $6E16M.createContainer)({
    displayName: 'JiraIssueAICommentsContainer'
});
const $2d19e9c880cf2878$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    initialState: $2d19e9c880cf2878$export$d4c72bab9d6cc13a,
    actions: $2d19e9c880cf2878$export$e324594224ef24da,
    name: 'jira-issue-ai-comments',
    containedBy: $2d19e9c880cf2878$export$c65ed21eaf08fc53,
    handlers: {
        onInit: ()=>({ setState: setState }, props)=>{
                const { commentTypes: commentTypes, commentTypeOptions: commentTypeOptions } = (0, $gxWPa.getAvailableCommentTypeOptions)(props);
                setState({
                    availableCommentTypeOptions: commentTypeOptions,
                    availableCommentTypes: commentTypes
                });
            },
        onContainerUpdate: (nextProps)=>({ setState: setState, getState: getState })=>{
                const { commentTypes: commentTypes, commentTypeOptions: commentTypeOptions } = (0, $gxWPa.getAvailableCommentTypeOptions)({
                    ...nextProps,
                    acceptedCommentTypes: getState().acceptedCommentTypes
                });
                // clean the suggestedComments when the container props are updated
                setState({
                    availableCommentTypes: commentTypes,
                    availableCommentTypeOptions: commentTypeOptions,
                    suggestedComments: null,
                    currentCommentType: null
                });
            }
    }
});
const $2d19e9c880cf2878$export$a504bc7744cc367c = (0, $iJq0l.createHook)($2d19e9c880cf2878$export$390f32400eaf98c9);
const $2d19e9c880cf2878$var$getCurrentComment = (state)=>{
    const currentComment = state.currentCommentType && state.suggestedComments && state.suggestedComments[state.currentCommentType];
    return {
        currentCommentType: state.currentCommentType,
        currentComment: currentComment
    };
};
const $2d19e9c880cf2878$export$32679da3f57e8e7a = (0, $iJq0l.createHook)($2d19e9c880cf2878$export$390f32400eaf98c9, {
    selector: $2d19e9c880cf2878$var$getCurrentComment
});

});
parcelRegister("gxWPa", function(module, exports) {
$parcel$export(module.exports, "getAvailableCommentTypeOptions", () => $7f302f47b6983509$export$3aa04d9ec62a82aa);

var $4DebH = parcelRequire("4DebH");

var $dPjFV = parcelRequire("dPjFV");
const $7f302f47b6983509$var$maxNumberOfCommentTypes = 3;
const $7f302f47b6983509$var$getAvailableCommentTypes = ({ totalOfComments: totalOfComments, hasMissingAssignee: hasMissingAssignee, hasMissingDescription: hasMissingDescription, acceptedCommentTypes: acceptedCommentTypes })=>{
    let result = [];
    if (totalOfComments > 0) result.push((0, $4DebH.SuggestedCommentReplyAgentCommentType).JIRA_COMMENT_REPLY);
    if (hasMissingAssignee) result.push((0, $4DebH.SuggestedCommentReplyAgentCommentType).JIRA_ASSIGNEE_MISSING);
    if (hasMissingDescription) result.push((0, $4DebH.SuggestedCommentReplyAgentCommentType).JIRA_DESCRIPTION_MISSING);
    result.push((0, $4DebH.SuggestedCommentReplyAgentCommentType).JIRA_STATUS_UPDATE);
    result.push((0, $4DebH.SuggestedCommentReplyAgentCommentType).JIRA_MOTIVATION);
    if (acceptedCommentTypes) result = result.filter((commentType)=>!acceptedCommentTypes.includes(commentType));
    // always returns the three general comment types
    result.push((0, $4DebH.SuggestedCommentReplyAgentCommentType).QUICK_REPLY);
    result.push((0, $4DebH.SuggestedCommentReplyAgentCommentType).QUESTION);
    result.push((0, $4DebH.SuggestedCommentReplyAgentCommentType).SUGGESTION);
    return result;
};
const $7f302f47b6983509$var$getDisplayMessageForCommentType = (commentType)=>{
    switch(commentType){
        case (0, $4DebH.SuggestedCommentReplyAgentCommentType).JIRA_COMMENT_REPLY:
            return (0, $dPjFV.default).commentReply;
        case (0, $4DebH.SuggestedCommentReplyAgentCommentType).JIRA_ASSIGNEE_MISSING:
            return (0, $dPjFV.default).assigneeMissing;
        case (0, $4DebH.SuggestedCommentReplyAgentCommentType).JIRA_DESCRIPTION_MISSING:
            return (0, $dPjFV.default).descriptionMissing;
        case (0, $4DebH.SuggestedCommentReplyAgentCommentType).JIRA_STATUS_UPDATE:
            return (0, $dPjFV.default).statusUpdate;
        case (0, $4DebH.SuggestedCommentReplyAgentCommentType).JIRA_MOTIVATION:
            return (0, $dPjFV.default).motivation;
        case (0, $4DebH.SuggestedCommentReplyAgentCommentType).QUICK_REPLY:
            return (0, $dPjFV.default).quickReply;
        case (0, $4DebH.SuggestedCommentReplyAgentCommentType).QUESTION:
            return (0, $dPjFV.default).question;
        case (0, $4DebH.SuggestedCommentReplyAgentCommentType).SUGGESTION:
            return (0, $dPjFV.default).suggestion;
        default:
            return null;
    }
};
const $7f302f47b6983509$export$3aa04d9ec62a82aa = (props)=>{
    const availableCommentTypes = $7f302f47b6983509$var$getAvailableCommentTypes(props);
    const commentTypes = [];
    const commentTypeOptions = [];
    availableCommentTypes.forEach((commentType)=>{
        const displayMessage = $7f302f47b6983509$var$getDisplayMessageForCommentType(commentType);
        if (!displayMessage) return;
        commentTypes.push(commentType);
        commentTypeOptions.push({
            value: commentType,
            message: displayMessage
        });
    });
    return {
        commentTypes: commentTypes.slice(0, $7f302f47b6983509$var$maxNumberOfCommentTypes),
        commentTypeOptions: commentTypeOptions.slice(0, $7f302f47b6983509$var$maxNumberOfCommentTypes)
    };
};

});
parcelRegister("dPjFV", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f0a7e1f99066937$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8f0a7e1f99066937$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    commentReply: {
        "id": "canned-comments.ui.ai-comments.comment-reply",
        "defaultMessage": "Suggest a reply..."
    },
    assigneeMissing: {
        "id": "canned-comments.ui.ai-comments.assignee-missing",
        "defaultMessage": "Who is working on this...?"
    },
    descriptionMissing: {
        "id": "canned-comments.ui.ai-comments.description-missing",
        "defaultMessage": "Can I get more info...?"
    },
    statusUpdate: {
        "id": "canned-comments.ui.ai-comments.status-update",
        "defaultMessage": "Status update..."
    },
    motivation: {
        "id": "canned-comments.ui.ai-comments.motivation",
        "defaultMessage": "Thanks..."
    },
    quickReply: {
        "id": "canned-comments.ui.ai-comments.quick-reply",
        "defaultMessage": "Agree..."
    },
    question: {
        "id": "canned-comments.ui.ai-comments.question",
        "defaultMessage": "Ask a question..."
    },
    suggestion: {
        "id": "canned-comments.ui.ai-comments.suggestion",
        "defaultMessage": "Add a suggestion..."
    }
});

});




parcelRegister("kZiT0", function(module, exports) {
$parcel$export(module.exports, "useAICommentsInteraction", () => $938b86f1929e7826$export$5f20b817e531bdea);

var $eJOHy = parcelRequire("eJOHy");

var $b1fSH = parcelRequire("b1fSH");

var $ln6Iy = parcelRequire("ln6Iy");

var $bmoS1 = parcelRequire("bmoS1");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $bNexr = parcelRequire("bNexr");

var $hMmCV = parcelRequire("hMmCV");

var $fIu6L = parcelRequire("fIu6L");
const $938b86f1929e7826$export$5f20b817e531bdea = ()=>{
    const { fetchSuggestedComments: fetchSuggestedComments } = (0, $hMmCV.useAIComments)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ availableCommentTypes: availableCommentTypes, suggestedComments: suggestedComments, isLoading: isLoading }, { setSuggestedComments: setSuggestedComments, setCurrentCommentType: setCurrentCommentType, setShowGeneratedComment: setShowGeneratedComment, setIsLoading: setIsLoading }] = (0, $fIu6L.useAICommentsStates)();
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError } = (0, $b1fSH.useAIEventsInstrumentation)();
    const onFail = (0, $eJOHy.useCallback)((type)=>(error)=>{
            setShowGeneratedComment(false);
            trackAIResultError({
                aiErrorMessage: error?.message
            }, {
                attributes: {
                    aiExperienceName: type
                }
            });
        }, [
        setShowGeneratedComment,
        trackAIResultError
    ]);
    const handleCommentButtonClick = (0, $eJOHy.useCallback)((type)=>{
        trackAIInteractionInit({
            attributes: {
                aiExperienceName: type
            }
        });
        setCurrentCommentType(type);
        setShowGeneratedComment(true);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'aiCannedComment', {
            commentType: type
        });
        if (!(0, $hMmCV.hasSuggestedComment)(type, suggestedComments) && !isLoading && (projectType === (0, $ln6Iy.CORE_PROJECT) || projectType === (0, $ln6Iy.SOFTWARE_PROJECT))) {
            setIsLoading(true);
            fetchSuggestedComments({
                issueKey: issueKey,
                projectType: projectType,
                selectedType: type,
                commentTypes: availableCommentTypes,
                onFail: onFail(type)
            }).then((data)=>{
                setSuggestedComments(data);
                setIsLoading(false);
            });
        }
    }, [
        availableCommentTypes,
        createAnalyticsEvent,
        fetchSuggestedComments,
        isLoading,
        issueKey,
        onFail,
        projectType,
        setCurrentCommentType,
        setIsLoading,
        setShowGeneratedComment,
        setSuggestedComments,
        suggestedComments,
        trackAIInteractionInit
    ]);
    return {
        handleCommentButtonClick: handleCommentButtonClick
    };
};

});
parcelRegister("hMmCV", function(module, exports) {
$parcel$export(module.exports, "hasSuggestedComment", () => $f2ef6b6d670c49b4$export$80e3c119f6b7d69d);
$parcel$export(module.exports, "useAIComments", () => $f2ef6b6d670c49b4$export$3e328d6638b73280);

var $eJOHy = parcelRequire("eJOHy");

var $hqYEY = parcelRequire("hqYEY");

var $4DebH = parcelRequire("4DebH");

var $4pbSJ = parcelRequire("4pbSJ");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $bILK0 = parcelRequire("bILK0");

var $2cfd4 = parcelRequire("2cfd4");

var $4mdYy = parcelRequire("4mdYy");

var $h5KpI = parcelRequire("h5KpI");
const $f2ef6b6d670c49b4$var$transformComments = (comments)=>{
    if (!comments) return null;
    const results = {};
    comments.forEach((comment)=>{
        if (comment.commentType === (0, $4DebH.SuggestedCommentReplyAgentCommentType).QUICK_REPLY || comment.commentType === (0, $4DebH.SuggestedCommentReplyAgentCommentType).QUESTION || comment.commentType === (0, $4DebH.SuggestedCommentReplyAgentCommentType).SUGGESTION || comment.commentType === (0, $4DebH.SuggestedCommentReplyAgentCommentType).JIRA_STATUS_UPDATE || comment.commentType === (0, $4DebH.SuggestedCommentReplyAgentCommentType).JIRA_COMMENT_REPLY || comment.commentType === (0, $4DebH.SuggestedCommentReplyAgentCommentType).JIRA_ASSIGNEE_MISSING || comment.commentType === (0, $4DebH.SuggestedCommentReplyAgentCommentType).JIRA_DESCRIPTION_MISSING || comment.commentType === (0, $4DebH.SuggestedCommentReplyAgentCommentType).JIRA_MOTIVATION) results[comment.commentType] = comment.text;
    });
    return results;
};
const $f2ef6b6d670c49b4$export$80e3c119f6b7d69d = (selectedType, suggestedComments)=>{
    if (!suggestedComments) return false;
    const comment = suggestedComments[selectedType];
    return !!comment;
};
const $f2ef6b6d670c49b4$var$getSuggestedComments = async (issueKey, locale, projectType, commentTypes, stopMetric)=>{
    const comments = await (0, $4pbSJ.invokeAIFeature)((0, $4DebH.SUGGESTED_COMMENT_AGENT_EXPERIENCE_ID), {
        ai_feature_path: (0, $4DebH.SUGGESTED_COMMENT_AGENT_AI_FEATURE_PATH),
        ai_feature_input: {
            object_id: issueKey,
            locale: locale,
            product: (0, $4mdYy.getConvoAIProductReferrerKey)(projectType),
            comment_type: commentTypes,
            adf_format: false
        }
    });
    stopMetric();
    const result = $f2ef6b6d670c49b4$var$transformComments(comments?.ai_feature_output?.commentSuggestions);
    return result;
};
const $f2ef6b6d670c49b4$export$3e328d6638b73280 = ()=>{
    const locale = (0, $2cfd4.useNativeLocale)();
    const startExperience = (0, $8Uqf3.useExperienceStart)((0, $h5KpI.AI_COMMENTS_EXPERIENCE));
    const markExperienceSuccess = (0, $4ctwv.useExperienceSuccess)((0, $h5KpI.AI_COMMENTS_EXPERIENCE));
    const markExperienceFailed = (0, $aqnJa.useExperienceFail)((0, $h5KpI.AI_COMMENTS_EXPERIENCE));
    const aiCommentsMetric = (0, $hqYEY.metrics).interaction({
        key: (0, $h5KpI.AI_COMMENTS_METRIC_KEY),
        histogram: (0, $h5KpI.AI_COMMENTS_HISTOGRAM)
    });
    const { showFlag: showFlag, dismissFlag: dismissFlag, hasFlag: hasFlag } = (0, $bILK0.useFlagsService)();
    const fetchSuggestedComments = (0, $eJOHy.useCallback)(async ({ issueKey: issueKey, projectType: projectType, selectedType: selectedType, commentTypes: commentTypes, onFail: onFail })=>{
        startExperience();
        aiCommentsMetric.start();
        if (hasFlag?.((0, $h5KpI.FETCH_SUGGESTED_COMMENTS_FAILED_FLAG_ID))) dismissFlag((0, $h5KpI.FETCH_SUGGESTED_COMMENTS_FAILED_FLAG_ID));
        try {
            const suggestedComments = await $f2ef6b6d670c49b4$var$getSuggestedComments(issueKey, locale, projectType, commentTypes, ()=>aiCommentsMetric.stop());
            if ($f2ef6b6d670c49b4$export$80e3c119f6b7d69d(selectedType, suggestedComments)) {
                markExperienceSuccess();
                return suggestedComments;
            }
            throw new Error('Selected comment type not returned');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            aiCommentsMetric.stop();
            markExperienceFailed('use-ai-comment', error, {
                commentTypes: commentTypes?.toString() || ''
            });
            showFlag((0, $h5KpI.FETCH_SUGGESTED_COMMENTS_FAILED_FLAG));
            onFail?.(error);
            return null;
        }
    }, [
        aiCommentsMetric,
        dismissFlag,
        hasFlag,
        locale,
        markExperienceFailed,
        markExperienceSuccess,
        showFlag,
        startExperience
    ]);
    return {
        fetchSuggestedComments: fetchSuggestedComments
    };
};

});
parcelRegister("h5KpI", function(module, exports) {
$parcel$export(module.exports, "AI_COMMENTS_EXPERIENCE", () => $03259d01cddfe19c$export$9e8dbe7f414e4b21);
$parcel$export(module.exports, "AI_COMMENTS_METRIC_KEY", () => $03259d01cddfe19c$export$f568908f52305df);
$parcel$export(module.exports, "AI_COMMENTS_HISTOGRAM", () => $03259d01cddfe19c$export$2d97240efd3f3354);
$parcel$export(module.exports, "FETCH_SUGGESTED_COMMENTS_FAILED_FLAG_ID", () => $03259d01cddfe19c$export$2c80090550f69a27);
$parcel$export(module.exports, "FETCH_SUGGESTED_COMMENTS_FAILED_FLAG", () => $03259d01cddfe19c$export$e0e9ed902e4c8515);

var $hYQLQ = parcelRequire("hYQLQ");

var $g2MyN = parcelRequire("g2MyN");
const $03259d01cddfe19c$export$9e8dbe7f414e4b21 = {
    experience: 'AISuggestedComments',
    experienceId: 'fetchAISuggestedComments',
    analyticsSource: (0, $hYQLQ.APP_IDENTIFIER)
};
const $03259d01cddfe19c$export$f568908f52305df = `${(0, $hYQLQ.APP_IDENTIFIER)}.fetch-ai-suggested-comments`;
const $03259d01cddfe19c$export$2d97240efd3f3354 = {
    result: '1000_2000_3000_4000_5000_10000',
    response: '1000_2000_3000_4000_5000_10000'
};
const $03259d01cddfe19c$export$2c80090550f69a27 = 'fetch-suggested-comments-failed-flag';
const $03259d01cddfe19c$export$e0e9ed902e4c8515 = {
    id: $03259d01cddfe19c$export$2c80090550f69a27,
    type: 'error',
    isAutoDismiss: true,
    title: (0, $g2MyN.default).fetchErrorFlagTitle,
    description: (0, $g2MyN.default).fetchErrorFlagDescription,
    messageId: 'canned-comments.services.use-ai-comments.fetch-suggested-comments-failed-flag.error.error.fetch-suggested-comments-failed-flag',
    messageType: 'transactional'
};

});
parcelRegister("g2MyN", function(module, exports) {
$parcel$export(module.exports, "default", () => $a15e084af686dc38$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a15e084af686dc38$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    fetchErrorFlagTitle: {
        "id": "project-create-importer.upload-flow.fetch-error-flag-title",
        "defaultMessage": "AI generation error"
    },
    fetchErrorFlagDescription: {
        "id": "project-create-importer.upload-flow.fetch-error-flag-description",
        "defaultMessage": "There was an error generating a response. Please wait a while and try again."
    }
});

});




parcelRegister("hOfDU", function(module, exports) {
$parcel$export(module.exports, "default", () => $aba0c16d3475c060$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $crJFo = parcelRequire("crJFo");

var $5CSKW = parcelRequire("5CSKW");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $ix0Ab = parcelRequire("ix0Ab");

var $b1fSH = parcelRequire("b1fSH");

var $fGind = parcelRequire("fGind");

var $hugns = parcelRequire("hugns");

var $iwl84 = parcelRequire("iwl84");

var $2Sr3y = parcelRequire("2Sr3y");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $fIu6L = parcelRequire("fIu6L");

var $d7IWw = parcelRequire("d7IWw");

var $4HP7S = parcelRequire("4HP7S");

var $ekRX1 = parcelRequire("ekRX1");
const $aba0c16d3475c060$var$AIGeneratedComment = ({ isLoading: isLoading, onDismiss: onDismiss, onInsertComment: onInsertComment })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ currentComment: currentComment, currentCommentType: currentCommentType }] = (0, $fIu6L.useCurrentComment)();
    const aiContentRef = (0, $eJOHy.useRef)(null);
    const generatingRef = (0, $eJOHy.useRef)(null);
    const currentAdfContent = (0, $eJOHy.useMemo)(()=>{
        if (!currentComment) return null;
        return (0, $iwl84.encodeAdf)(currentComment, true);
    }, [
        currentComment
    ]);
    const streamingContent = (0, $eJOHy.useMemo)(()=>{
        return currentAdfContent ? (0, $d7IWw.adfToText)(currentAdfContent) : undefined;
    }, [
        currentAdfContent
    ]);
    const { delayedContent: delayedContent, isComplete: isComplete } = (0, $hugns.useAIMockStreaming)(streamingContent);
    const adfContent = (0, $eJOHy.useMemo)(()=>{
        if (!delayedContent) return null;
        return isComplete ? currentAdfContent : (0, $iwl84.encodeAdf)(delayedContent, true);
    }, [
        currentAdfContent,
        delayedContent,
        isComplete
    ]);
    const { trackAIResultView: trackAIResultView } = (0, $b1fSH.useAIEventsInstrumentation)();
    (0, $eJOHy.useEffect)(()=>{
        if (isLoading && aiContentRef.current && (0, $7jTnu.fg)('jira_issue_next_best_actions_fg')) // This is needed to ensure everything runs (eg. close modal) before attempting to scroll.
        setTimeout(()=>{
            (0, $crJFo.smoothScrollIntoCenterIfNeeded)(aiContentRef.current);
        }, 0);
    }, [
        isLoading
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isLoading && currentComment) trackAIResultView({
            attributes: {
                aiExperienceName: currentCommentType ?? undefined
            }
        });
    }, [
        currentComment,
        currentCommentType,
        isLoading,
        trackAIResultView
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isLoading && generatingRef.current) generatingRef.current.focus();
    }, [
        isLoading
    ]);
    const onInsertClick = (0, $eJOHy.useCallback)(()=>{
        adfContent && onInsertComment(adfContent);
    }, [
        adfContent,
        onInsertComment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        ref: aiContentRef,
        padding: "space.200"
    }, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4HP7S.GeneratingAnimation), null), (0, $7jTnu.fg)('jfp_a11y_27001_fix_focus_movement') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        padding: "space.025",
        ref: generatingRef,
        role: "status",
        "aria-atomic": "true",
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text.subtlest"
    }, formatMessage((0, $ekRX1.default).generating))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        padding: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text.subtlest"
    }, formatMessage((0, $ekRX1.default).generating)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: ()=>onDismiss(false)
    }, formatMessage((0, $ekRX1.default).cancel)))), !isLoading && adfContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fGind.AITelepointerWrapper), {
        hideTelepointer: isComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ix0Ab.default), {
        document: adfContent
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.100",
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: ()=>onDismiss(true),
        isDisabled: !isComplete
    }, formatMessage((0, $ekRX1.default).discard)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "primary",
        onClick: onInsertClick,
        isDisabled: !isComplete
    }, formatMessage((0, $ekRX1.default).insert))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Sr3y.AiFooter), {
        testId: "canned-comments.ui.ai-comments.ai-generated-comment.footer",
        isBeta: !isLoading,
        showDisclaimer: !isLoading,
        showAttributionLink: true
    }));
};
var $aba0c16d3475c060$export$2e2bcd8739ae039 = $aba0c16d3475c060$var$AIGeneratedComment;

});
parcelRegister("fGind", function(module, exports) {
$parcel$export(module.exports, "AITelepointerWrapper", () => $86014763c01ff373$export$e372ffc7075fd6f3);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $86014763c01ff373$var$telepointerStyles = (0, $1DXK0.xcss)({
    display: 'inline-block',
    position: 'absolute',
    width: '1.5px',
    height: '25px',
    background: 'linear-gradient(45deg, #F8E6A0 -12.02%, #8BDBE5 19.18%, #0C66E4 71.87%)',
    marginLeft: 'space.025',
    marginTop: 'space.negative.100',
    '::after': {
        content: '"AI"',
        position: 'absolute',
        display: 'block',
        top: 'space.0',
        left: 'space.0',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '10px',
        fontWeight: 'font.weight.bold',
        width: '12.5px',
        height: '13px',
        paddingTop: 'space.025',
        paddingLeft: 'space.025',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 'initial',
        borderRadius: `0px ${"var(--ds-radius-xsmall, 2px)"} ${"var(--ds-radius-xsmall, 2px)"} 0px`,
        color: 'color.text.inverse',
        background: 'linear-gradient(45deg, #8BDBE5 -57%, #0C66E4 71.87%)'
    }
});
const $86014763c01ff373$var$isAValidContainer = (node)=>{
    if (node.hasChildNodes() && node.lastChild?.nodeType !== Node.TEXT_NODE) return true;
    return false;
};
const $86014763c01ff373$var$getNestedLastChild = (originNode)=>{
    if ($86014763c01ff373$var$isAValidContainer(originNode) && originNode.lastChild) return $86014763c01ff373$var$getNestedLastChild(originNode.lastChild);
    else if (originNode.textContent === '' && originNode.parentNode) return originNode.parentNode;
    else return originNode;
};
const $86014763c01ff373$export$e372ffc7075fd6f3 = ({ hideTelepointer: hideTelepointer = false, children: children })=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const telepointerRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (!hideTelepointer) {
            const renderer = containerRef.current;
            if (renderer.lastChild && telepointerRef.current) $86014763c01ff373$var$getNestedLastChild(renderer.lastChild).appendChild(telepointerRef.current);
        }
    }, [
        children,
        hideTelepointer
    ]);
    if (hideTelepointer) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                as: "span",
                ref: telepointerRef,
                xcss: $86014763c01ff373$var$telepointerStyles,
                testId: "ai-telepointer-cursor"
            }),
            children
        ]
    });
};

});

parcelRegister("hugns", function(module, exports) {
$parcel$export(module.exports, "useAIMockStreaming", () => $034cb62c0143d008$export$400bbe8ab4bcbef3);

var $eJOHy = parcelRequire("eJOHy");
const $034cb62c0143d008$export$400bbe8ab4bcbef3 = (content, totalDuration = 1000, intervalDuration = 50)=>{
    const [delayedContent, setDelayedContent] = (0, $eJOHy.useState)('');
    const [isComplete, setIsComplete] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        const contentLength = content?.length || 0;
        const numberOfUpdates = totalDuration / intervalDuration;
        const increment = Math.ceil(contentLength / numberOfUpdates);
        let currentIndex = 0;
        let interval;
        if (content?.length) interval = setInterval(()=>{
            currentIndex += increment;
            if (currentIndex >= contentLength) {
                currentIndex = contentLength;
                clearInterval(interval);
                setIsComplete(true);
            }
            setDelayedContent(content.slice(0, currentIndex));
        }, intervalDuration);
        return ()=>clearInterval(interval);
    }, [
        content,
        intervalDuration,
        totalDuration
    ]);
    return {
        delayedContent: delayedContent,
        isComplete: isComplete
    };
};

});

parcelRegister("4HP7S", function(module, exports) {
$parcel$export(module.exports, "GeneratingAnimation", () => $b4d0e0adec7ab099$export$483f53d5a0354a30);

var $eJOHy = parcelRequire("eJOHy");
const $b4d0e0adec7ab099$export$483f53d5a0354a30 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));

});

parcelRegister("ekRX1", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8cbf5e9c3b4ab73$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c8cbf5e9c3b4ab73$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    generating: {
        "id": "canned-comments.ui.ai-comments.ai-generated-comment.generating",
        "defaultMessage": "Generating"
    },
    insert: {
        "id": "canned-comments.ui.ai-comments.ai-generated-comment.insert",
        "defaultMessage": "Insert"
    },
    discard: {
        "id": "canned-comments.ui.ai-comments.ai-generated-comment.discard",
        "defaultMessage": "Discard"
    },
    cancel: {
        "id": "canned-comments.ui.ai-comments.ai-generated-comment.cancel",
        "defaultMessage": "Cancel"
    }
});

});




$parcel$global.rlb("9nhJS")
//# sourceMappingURL=index-new.ca1d9200.js.map
